import { Badge, Divider, Paper, Stack, Typography } from '@mui/material'
import SeriesDefinitionInstance from '../series/SeriesDefinitionInstance'
import { Fragment } from 'react/jsx-runtime'
import { QcTaskExamDescription } from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import SourceStudyDescriptionChip from '../qc/SourceStudyDescriptionChip'

export default function StudyAndSeriesDefinitionInstance({
  qcTaskExamDescription,
  qcStatus,
  order,
}: {
  qcTaskExamDescription: QcTaskExamDescription
  qcStatus: string
  order: number
}) {
  return (
    <Stack spacing={SPACING.spacingXl}>
      <Paper
        sx={{
          padding: SPACING.spacingLg,
          borderRadius: SPACING.borderRadiusXxl,
          bgcolor: 'paper.main',
        }}
      >
        <Stack spacing={SPACING.spacingLg}>
          <Stack spacing={SPACING.spacingXs}>
            <Typography
              variant="subtitle2"
              sx={{
                color: 'text.secondary',
              }}
            >
              New study description
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.primary',
              }}
            >
              {qcTaskExamDescription.study_description}
            </Typography>
          </Stack>
          <Stack spacing={SPACING.spacingSm}>
            <Typography
              variant="subtitle2"
              sx={{
                color: 'text.secondary',
              }}
            >
              Source study description
            </Typography>
            <Stack direction="row" spacing={SPACING.spacingSm} alignItems="center" justifyContent="start">
              {qcTaskExamDescription.source_study_description.map((sourceStudyDescription) => (
                <SourceStudyDescriptionChip
                  key={sourceStudyDescription.container_submission_exam_metadata_id}
                  description={sourceStudyDescription.study_description || ''}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>
      </Paper>
      <Stack spacing={SPACING.minSpacing}>
        <Stack direction="row" alignItems="center" justifyContent="start" spacing={SPACING.spacingLg}>
          <Typography
            variant="subtitle1"
            sx={{
              color: 'text.secondary',
            }}
          >
            Series
          </Typography>
          <Badge badgeContent={qcTaskExamDescription.series_descriptions.length} color="secondary" />
        </Stack>
        <Paper
          sx={{
            padding: SPACING.spacingLg,
            borderRadius: SPACING.borderRadiusXxl,
            bgcolor: 'paper.main',
          }}
        >
          <Stack spacing={SPACING.spacingSm}>
            {qcTaskExamDescription.series_descriptions.map((seriesDescription, index) => (
              <Fragment key={seriesDescription.submission_series_id}>
                <SeriesDefinitionInstance
                  studyDescription={qcTaskExamDescription.study_description ?? ''}
                  qcStatus={qcStatus}
                  order={order}
                  seriesDescription={seriesDescription}
                />
                {index !== qcTaskExamDescription.series_descriptions.length - 1 && <Divider />}
              </Fragment>
            ))}
          </Stack>
        </Paper>
      </Stack>
    </Stack>
  )
}
